import React, { useEffect, useState, useContext } from "react";
import { Button, TextField } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import { AuthContext } from "../../../../helpers/AuthContext";
import DataTable from "../../../../components/DataTable"; // Import your DataTable component

//import './style.css';

import EliteMachinesUI2 from "./EliteMachinesUI2";
import EliteMachinesTab from "./EliteMachinesTab";

const MachineManagements = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const { authState } = useContext(AuthContext);
  let history = useHistory();

  return (
    <>
      <div className="instance-dashboard">
        <InstanceLeftSidebar />
        <div className="rightSide">
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <PageHeaderWithBreadcrumbs
                title="Machine Management"
                breadcrumb="Machine Management"
                includeButton={false}
              />
              {/* <Container fluid> */}
              {/* <div>
              </div> */}
              {/* </Container> */}
              {/* Data Table Section for Web Stores */}
              {/* <p>Analytics design template to be developed</p> */}
              {/* <EliteMachinesUI2 /> */}
              <EliteMachinesTab />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MachineManagements;
